module.exports = __webpack_public_path__ + "img/slogn.bf421296.png";